import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * Validator that treats whitespace-only input as empty.
 * Use this instead of Validators.required when trimming is needed.
 */
export function trimmedRequired(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (value === null || value === undefined || (typeof value === "string" && value.trim().length === 0)) {
            return { required: true };
        }

        return null;
    };
}
